import Grid from '@mui/material/Grid';
import {bool, number, object, string} from 'prop-types';
import React from 'react';
import TextField from './TextField.jsx';

const http = 'http://';
const https = 'https://';

function toUrl(value) {
  if (
    !value ||
    value.startsWith(http) ||
    value.startsWith(https) ||
    https.startsWith(value) ||
    http.startsWith(value)
  ) {
    return value;
  }
  return 'https://' + value;
}

const LinkGroup = ({
  requireTitle = true,
  value,
  index = 0,
  rel,
  required = false,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 6}} sx={{display: requireTitle ? 'block' : 'none'}}>
        <TextField
          name={`links.${index}.title`}
          label="Title"
          defaultValue={rel === 'alternate' ? 'Publication' : value?.title}
          fullWidth
          required={required}
        />
      </Grid>

      <Grid size={{xs: requireTitle ? 6 : 12}}>
        <TextField
          name={`links.${index}.href`}
          label="URL"
          fullWidth
          required={required}
          defaultValue={value?.href}
          transform={{input: toUrl}}
          type="url"
        />
        <TextField
          label="hidden"
          type="hidden"
          sx={{display: 'none'}}
          name={`links.${index}.rel`}
          defaultValue={rel}
        />
        <TextField
          label="hidden"
          type="hidden"
          sx={{display: 'none'}}
          name={`links.${index}.type`}
          defaultValue=""
        />
      </Grid>
    </Grid>
  );
};

LinkGroup.propTypes = {
  requireTitle: bool,
  value: object,
  index: number,
  required: bool,
  rel: string,
};

export default LinkGroup;
